import moment from 'moment';
import { ApolloError } from '@apollo/client';
import {
  TimeSeriesInputInterval,
  useGetJobsiteTimeSeriesQuery,
} from 'apollo/generated/client-operations';
import { JobsiteFormSubmission } from 'containers/jobsiteFormSubmission/print/types';
import { getDateTimeMoment } from 'utils/dates';
import { useUpdateQueryStatus } from './useUpdateQueryStatus';

export type UseWorkersOnSiteData = {
  loading: boolean;
  error: ApolloError;
  workersOnSite: number;
};

export const useWorkersOnSite = (
  jobsiteFormSubmission: JobsiteFormSubmission,
): UseWorkersOnSiteData => {
  const { startAt } = jobsiteFormSubmission;
  const { jobsiteId } = jobsiteFormSubmission.jobsiteForm.jobsite;

  const startOfDate = moment.utc(startAt).startOf('day').toDate();
  const endOfDate = moment.utc(startAt).endOf('day').toDate();

  const {
    data: timeSeriesData,
    loading,
    error,
  } = useGetJobsiteTimeSeriesQuery({
    fetchPolicy: 'no-cache',
    skip: !jobsiteId,
    variables: {
      jobsiteId,
      timeSeriesInput: {
        startDateTime: startOfDate,
        endDateTime: endOfDate,
        interval: TimeSeriesInputInterval.Every_15Minutes,
      },
    },
  });
  useUpdateQueryStatus('workersOnSite', { loading, error });

  const currentTimeMoment = getDateTimeMoment({ date: startAt, isUTC: true });
  const { timeSeries } = timeSeriesData?.getJobsite ?? {};
  const workersOnSite =
    timeSeries?.sessions.find((session) =>
      moment(session.dateTime).isSameOrAfter(currentTimeMoment),
    )?.value ?? 0;

  return {
    loading,
    error,
    workersOnSite,
  };
};
